var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var Guide = function () {
            function Guide() {
                _classCallCheck(this, Guide);

                this.modal = window.modal;

                this.handlers();
            }

            _createClass(Guide, [{
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    eventDispatcher.addAllEvent('click', '.js-show-guide-modal', function (event) {
                        var target = event.currentTarget;
                        var theme = _this._resolveTheme(target);

                        if (target.dataset && target.dataset.guideLazy === '1') {
                            window.eventDispatcher.dispatchEvent('guide:open-lazy', {
                                theme: theme,
                                target: target
                            });
                            return;
                        }

                        _this.open(theme);
                    });
                }
            }, {
                key: "open",
                value: function open(theme) {
                    if (!theme) {
                        return;
                    }

                    var content = QS("#" + theme);

                    if (!content) {
                        return;
                    }

                    this.modal.open({
                        header: {
                            title: content.dataset.title,
                            theme: 'primary'
                        },
                        content: { htmlDetachSelectorId: theme },
                        parentCssClass: '',
                        footer: false,
                        type: 'full'
                    });
                }
            }, {
                key: "_resolveTheme",
                value: function _resolveTheme(target) {
                    if (target && target.dataset && target.dataset.theme) {
                        return target.dataset.theme;
                    }

                    var themeClass = Array.from(target.classList).find(function (className) {
                        return className.startsWith('js-show-');
                    });

                    return themeClass ? themeClass.replace('js-show-', '') : null;
                }
            }]);

            return Guide;
        }();

        window.Guide = new Guide();
    }, {}] }, {}, [1]);